import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import "./header.scss";
import display1 from "../../assets/desktop_bg.jpg";
import display1m from "../../assets/mobile_bg.jpg";
import display2m from "../../assets/Second_screen_mobile.png";
import display2 from "../../assets/Second_screen_desktop.png";
import Content from "../Content/Content";
import Button from "../Button/Button";
import Lottie from "react-lottie";
import animationData from "../../assets/lottie.json";
import smallRectangle from "../../assets/Small_rectangle_desktop.png";
import bigRectangleDesktop from "../../assets/chenar_desktop.png";
import bigRectangleMobile from "../../assets/chenar_mobil.png";
import plusSeparator from "../../assets/new_plus.svg";

import step1 from "../../assets/Step_1_desktop.png";
import step2 from "../../assets/Step_2_desktop.png";
import step3 from "../../assets/Step_3_desktop.png";

import DiceRoll from "../../assets/dice_roll_desktop.png";
import ShiningCrown from "../../assets/shining_crown_desktop.png";
import FlamingHot from "../../assets/flaming_hot_desktop.png";
import BurningHot from "../../assets/burning_hot_desktop.png";
import MixedGames from "../../assets/mixed_games_desktop.png";
import TopBar from "../TopBar/TopBar";
import useOnScreen from "../../hooks/useOnScreen";
import { Pagination } from "../Pagination/Pagination";
import { IPrize, Prizes } from "../Prizes/Prizes";
import clsx from "clsx";

const PRIZE_LIST: IPrize[] = [
  {
    image: DiceRoll,
    freeSpins: 100,
    bonus: 100,
    money: 1000,
  },
  {
    image: ShiningCrown,
    freeSpins: 50,
    bonus: 100,
    money: 800,
  },
  {
    image: FlamingHot,
    freeSpins: 100,
    bonus: 75,
    money: 750,
  },
  {
    image: BurningHot,
    freeSpins: 150,
    bonus: 50,
    money: 500,
  },
  {
    image: MixedGames,
    freeSpins: 300,
    bonus: 25,
    money: 250,
  },
];

interface IProps {
  showNav: boolean;
}

const Header: FunctionComponent<IProps> = ({ showNav }) => {
  const [activePage, setActivePage] = useState(1);
  const panel1 = useRef(null);
  const panel2 = useRef(null);
  const panel3 = useRef(null);
  const isPanelOneVisible = useOnScreen(panel1);
  const isPanelTwoVisible = useOnScreen(panel2);
  const isPanelThreeVisible = useOnScreen(panel3);

  // const defaultOptions = {
  //     loop: true,
  //     autoplay: true,
  //     animationData: animationData,
  //     rendererSettings: {
  //         preserveAspectRatio: "xMidYMid slice"
  //     }
  // };

  useEffect(() => {
    if (isPanelOneVisible) {
      setActivePage(1);
    }

    if (isPanelTwoVisible) {
      setActivePage(2);
    }

    if (isPanelThreeVisible) {
      setActivePage(3);
    }
  }, [isPanelOneVisible, isPanelTwoVisible, isPanelThreeVisible]);

  const isMobile = window.innerWidth <= 768;

  function scrollTo2ndPanel() {
    window.scrollTo({
      top: window.innerHeight,
      behavior: "smooth",
    });
  }

  return (
    <div className="header-container">
      <Pagination activePage={activePage} nrOfPages={3} visible={showNav} />
      <div className="header-display">
        <TopBar />
        <Content className={"header-content1"}>
          <div className="display1-content">
            <div ref={panel1} className="big-rectangle">
              <img
                className="rectangle-image"
                src={!isMobile ? bigRectangleDesktop : bigRectangleMobile}
                alt=""
              ></img>
              <div className="image-content-wrapper">
                <span className="top-rectangle-text">
                  Bonus în cazino la înregistrare
                </span>
                <div className="top-box-text">
                  <span className="big-rectangle-text">700</span>
                  <div className="split-box-text">
                    <span className="medium-rectangle-text">ROTIRI</span>
                    <span className="medium-rectangle-text">GRATUITE</span>
                  </div>
                </div>
                <div className="box-separator">
                  <div className="border-separator"></div>
                  <img src={plusSeparator} alt=""></img>
                </div>
                <span className="bottom-big-rectangle-text">3.300 RON</span>
              </div>
            </div>

            <Button
              href={"https://magnumbet.ro/casino/registration"}
              className="header-display1-button"
              variation={2}
            >
              PROFITĂ ACUM
            </Button>
          </div>
        </Content>
        <img src={isMobile ? display1m : display1} alt="display" />
        {/* <div onClick={scrollTo2ndPanel} className="lottie-cta">
                    <Lottie options={defaultOptions} width={50} height={80}/>
                </div> */}
      </div>

      <div className="header-display header-display2">
        <TopBar showMenu={false} />
        <Content className="header-content2">
          <div className="display2-content">
            <div className={"row-content-wrapper"}>
              <div className="row-content">
                <img src={step1} alt="step" />

                <div>
                  <p>DESCHIDE CONT</p>

                  <p>Durează 2 minute. Maxim.</p>
                </div>
              </div>
              <div className="row-content">
                <img src={step2} alt="step" />
                {isMobile && (
                  <div>
                  <p>
                    PRIMEȘTI <span>până la</span>
                  </p>

                  <p>700 ROTIRI GRATUITE</p>

                  <p>+ 3.300 RON</p>

                  <p ref={panel2}>la primele 5 depuneri</p>
                </div>
                )}
                {!isMobile && (
                  <div>
                    <span className="desktop-small-white-text">
                      Primești până la
                    </span>

                    <span className="desktop-big-white-text">
                      700 ROTIRI GRATUITE <br></br>+ 3300 RON
                    </span>

                    <span className="desktop-small-white-text">
                      la primele 5 depuneri
                    </span>
                  </div>
                )}
              </div>
              <div className="row-content">
                <img src={step3} alt="step" />

                {isMobile && (
                  <div>
                    <p>
                      Fă o primă depunere AZI
                    </p>

                    <p>Ia bonusul și</p>

                    <p className="magnum-gold">începe jocul</p>
                    
                  </div>
                )}

                {!isMobile && (
                  <div>
                    <span className="desktop-small-white-text">
                      Fă o primă depunere AZI
                    </span>

                    <span className="desktop-big-yellow-text" ref={panel2}>
                        Ia bonusul și
                    </span>
                  
                    <span className="desktop-big-yellow-text" ref={panel2}>
                        începe jocul
                    </span>
                  </div>
                )}
              </div>
            </div>
            <Button
              variation={2}
              href={"https://magnumbet.ro/registration"}
              className="open-account"
            >
              DESCHIDE CONT
            </Button>
          </div>
        </Content>
        <img src={isMobile ? display2m : display2} alt="display" />
      </div>

      <div className="header-display header-display3">
        <TopBar showMenu={false} />
        <Content className={"header-content1"}>
          <div className={clsx("display2-content", "display3-content")}>
            <Prizes prizes={PRIZE_LIST} />
            <Button
              variation={2}
              href={"https://magnumbet.ro/registration"}
              className="open-account"
            >
              DESCHIDE CONT
            </Button>
            <div ref={panel3} />
          </div>
        </Content>
      </div>
    </div>
  );
};

export default Header;
